import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Material
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

// Custom Modules
import { MessagesModule } from '@modules/messages/messages.module';

// Components
import { AdminComponent } from './components/admin/admin.component';
import { NewsComponent } from './components/news/news.component';
import { FilterModule } from '@modules/filter/filter.module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [AdminComponent, NewsComponent],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    FormsModule,
    BrowserModule,
    MatButtonModule,
    MatSelectModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTabsModule,
    MessagesModule,
    DragDropModule,
    BrowserAnimationsModule,
    MatCheckboxModule,
    FilterModule,
    MatDialogModule,
    MatTooltipModule,
    MatExpansionModule,
    MatIconModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatListModule,
    MatAutocompleteModule,
  ],
  exports: [AdminComponent],
})
export class AdminModule {}
